import React from 'react';
import { BrowserRouter } from 'react-router-dom';

import { ChainedRender } from './types';


export const BrowserRouterRender: ChainedRender = ({ Next }) => (
    <BrowserRouter>
        <Next />
    </BrowserRouter>
);
